import React from 'react';
import Icon from './Icon';
import { useSelector } from 'react-redux';

const LanguageListItem = ({ label, url, value, selected, onClick }) => {
  return (
    <li className="language-list__item">
      {selected ? (
        <div className="language-list__item--selected">
          <Icon name="Check" size={24} className="language-list__item-icon" />
          {label}
        </div>
      ) : (
        <button
          className="language-list__item--button"
          onClick={() => onClick(url)}
        >
          {label}
        </button>
      )}
    </li>
  );
};

const LanguageSelect = () => {
  const channelPicker = useSelector((state) => state.site.channelPicker);
  function handleRetailSelectClick(
    url
  ) {
    window.location.href = `${url}`;
  }
  return channelPicker ? (
    <ul className="language-list">
      {channelPicker.channelPickerItems.map((channelPickerItem, i) => (
        <LanguageListItem
          key={i+channelPickerItem.name}
          label={channelPickerItem.name}
          url={channelPickerItem.url}
          selected={channelPickerItem.channelSystemId === channelPicker.currentChannel.channelSystemId}
          onClick={handleRetailSelectClick}
          {...channelPickerItem}
        />
      ))}
    </ul>
  ) : null;
};

export default LanguageSelect;
